import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

type CustomFont = {
  fontFamily: string;
  name: string;
  url?: string;
};

export type BeeFreeLspSettingsV2 = {
  AiIntegrationEnabled: boolean;
  ClientUid: string;
  CustomFonts: CustomFont[];
};

export function useGetBeeFreeSettingsQuery({ enabled }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['beefree-settings'],
    queryFn: async () => fetchData<BeeFreeLspSettingsV2>('api/email-marketing-config/get-beefree-settings'),
    staleTime: 0,
    enabled,
  });
}
